import React from "react";
import { useTranslation } from "react-i18next";
import U2000ActionBtn from "../../../../u2000Core/components/buttons/U2000ActionBtn";
import U2000ResponsiveToolbar from "../../../../u2000Core/components/toolbar/U2000ResponsiveToolbar";
import { FaPlus, FaRegFile, FaTrashAlt } from "react-icons/fa";
import { useU2000AuthContext } from "../../../../u2000Core/context/auth/U2000UseAuthContext";
import type { U2000FormStateHandlersReturn } from "../../../../u2000Core/reducer/formReducer/U2000FormStateHandlers";
import { U2000FormStateEnumState } from "../../../../u2000Core/reducer/formReducer/U2000FormState";
import { NS, U3144ROLES } from "../../../U3144";
import type { U3144LotDetailOperationTypeFormRow } from "../../../U3144Service";

export type U3144LotDetailOperationTypeFormToolbarHandlers = U2000FormStateHandlersReturn<U3144LotDetailOperationTypeFormRow> & {
  addNewLotDetailOperationType: () => void;
  modifyLotDetailOperationType: () => void;
  deleteLotDetailOperationType: () => void | Promise<void>;
};

interface U3144LotDetailOperationTypeFormToolBarProps {
  formStateHandlers: U3144LotDetailOperationTypeFormToolbarHandlers;
}

export const U3144LotDetailOperationTypeFormToolBar: React.FC<U3144LotDetailOperationTypeFormToolBarProps> = ({ formStateHandlers }) => {
  const formState = formStateHandlers.getFormState();
  const { hasRole } = useU2000AuthContext();
  const { t } = useTranslation();

  const actions = [
    {
      key: "add",
      label: t("btnAdd", { ns: NS }),
      hasRole: hasRole(U3144ROLES.ADD),
      handleClick: () => {
        formStateHandlers.addNewLotDetailOperationType();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaPlus,
      Component: U2000ActionBtn,
    },
    {
      key: "modify",
      label: t("btnModify", { ns: NS }),
      hasRole: hasRole(U3144ROLES.EDIT),
      handleClick: () => {
        formStateHandlers.modifyLotDetailOperationType();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaRegFile,
      Component: U2000ActionBtn,
    },
    {
      key: "delete",
      label: t("btnDelete", { ns: NS }),
      hasRole: hasRole(U3144ROLES.DELETE),
      handleClick: () => {
        formStateHandlers.deleteLotDetailOperationType();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaTrashAlt,
      Component: U2000ActionBtn,
    },
  ];

  return <U2000ResponsiveToolbar actions={actions} />;
};
